import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LottieModule } from 'ngx-lottie';
import {
  RdsButtonModule,
  RdsDividerModule,
  RdsDropdownModule,
  RdsHeaderModule,
  RdsIconsModule,
  RdsMenuModule,
  RdsProgressBarModule,
  RdsTreeModule,
  RdsTabModule,
  RdsChipsModule,
  RdsLinkModule,
  RdsRadioButtonModule,
  RdsFormFieldModule,
  RdsDialogModule,
  RdsFooterModule,
  RdsBreadcrumbsModule,
  RdsPaginatorModule,
  RdsBadgeModule,
  RdsAvatarModule,
  RdsTableModule,
  RdsEmptyStateModule,
  RdsTooltipModule,
  RdsCheckboxModule,
  RdsSearchModule,
  RdsToggleButtonModule,
  RdsToastModule,
  RdsSwitchModule,
  RdsStepperModule,
  RdsAccordionModule,
  RdsUploadModule,
  RdsDatepickerModule,
  RdsNativeDateModule,
  RdsCarouselModule,
  RdsAlertModule,
  RdsProgressSpinnerModule
} from '@rds/angular-components';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RdsNativeDateModule,
    LottieModule.forRoot({ player: () => import("lottie-web") }),
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    RdsButtonModule,
    RdsDividerModule,
    RdsDropdownModule,
    RdsHeaderModule,
    RdsIconsModule,
    RdsMenuModule,
    RdsProgressBarModule,
    RdsTreeModule,
    RdsTabModule,
    RdsChipsModule,
    RdsLinkModule,
    RdsRadioButtonModule,
    RdsFormFieldModule,
    RdsDialogModule,
    RdsFooterModule,
    RdsBreadcrumbsModule,
    RdsPaginatorModule,
    RdsBadgeModule,
    RdsAvatarModule,
    RdsTableModule,
    RdsEmptyStateModule,
    RdsTooltipModule,
    RdsCheckboxModule,
    RdsSearchModule,
    RdsToggleButtonModule,
    RdsSwitchModule,
    RdsStepperModule,
    RdsAccordionModule,
    RdsUploadModule,
    RdsDatepickerModule,
    RdsCarouselModule,
    RdsAlertModule,
    RdsProgressSpinnerModule
  ]
})
export class RdsModule {}
